import { render } from "./NamePlateSmall.vue?vue&type=template&id=9e63ecca"
import script from "./NamePlateSmall.vue?vue&type=script&lang=js"
export * from "./NamePlateSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__